import React from 'react'
import { render, unmountComponentAtNode } from 'react-dom'
import { BaseNotifier } from './baseNotifier'
import Notification from '../elementals/notification'
import { Toaster, toast } from 'sonner'

const MAX_VISIBLE_TOASTS = 5

const defaultIconName = {
  info: 'info-circle',
  caution: 'exclamation-triangle',
  error: 'exclamation-circle',
  success: 'check-circle',
}

export class ToastNotifier extends BaseNotifier {
  constructor() {
    super()
    this._containerDomNode = null
  }

  initialize() {
    // attach notification to body, open it via ref
    this._containerDomNode = document.createElement('div')
    document.body.appendChild(this._containerDomNode)
    render(
      <Toaster
        visibleToasts={MAX_VISIBLE_TOASTS}
        toastOptions={{ unstyled: true }}
      />,
      this._containerDomNode
    )
  }

  open(initialOptions) {
    const options = super.prepareOptions(initialOptions)
    const {
      role,
      message,
      title,
      autoDismiss,
      dismissible,
      duration,
      showIcon,
      iconName,
    } = options

    /**
     * For now we won't do much with the returned toastId, other than use it to dismiss the toast - and use it
     * for unit testing.  In future, we may want to get more use out of it, TBD.
     */
    const toastId = toast(
      <Notification
        isVisible
        iconName={iconName || (showIcon ? defaultIconName[role] : null)}
        iconStyle='light'
        color={role}
        message={message}
        title={title}
        fluid
        onCloseButton={dismissible}
        onClose={
          dismissible
            ? () => {
                toast.dismiss(toastId)
              }
            : undefined
        }
      />,
      {
        description: message,
        duration: autoDismiss ? duration : Infinity,
      }
    )
    return toastId
  }

  close() {
    // not implemented for now
  }

  closeAll() {
    toast.dismiss()
  }

  destroy() {
    // unmount and remove the container from the body
    if (this._containerDomNode) {
      unmountComponentAtNode(this._containerDomNode)
      document.body.removeChild(this._containerDomNode)
    }
    super.destroy()
  }
}
